import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import DispatchContext from "../../contexts/DispatchContext";
import DataFetcher from "../../utils/DataFetcher";
import LoadingIndicator from "../elements/LoadingIndicator";
import { renderMarkup, dispError } from "../../utils/Tools";

function Contact(props) {
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();

  const targetURL = "/servicepage";
  const [page, setPage] = useState(null)

  const loadData = useCallback(() => {
    DataFetcher.fetch(targetURL, {"slug": `/kontakt`})
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        return setPage(response.page);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [appDispatch, history]);

  useEffect(() => {
    loadData()
  }, [loadData])

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="legal contact">
      { !page && (<LoadingIndicator />) }
      { page && <div className="content">{renderMarkup(page.rendered)}</div> }
    </main>
  );
}
export default Contact;
